<template>
    <div data-testid="drag-dropfile" class="main">
        <div data-testid="drag-dropfile__dropzone" class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input data-testid="drag-dropfile__input" type="file" :multiple="multiplefiles" name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
            :accept="accept" />
            <div data-testid="drag-dropfile__label" for="fileInput" class="file-label d-flex align-center justify-center">
                <div data-testid="drag-dropfile__dragging" v-if="isDragging">Release to drop files here.</div>
                <div data-testid="drag-dropfile__selected-names" v-else-if="fileName && fileName.length > 0" class="file-label" >
                  {{ fileName.map(file => file.name).join(', ') }}
                </div>
                <div data-testid="drag-dropfile__empty" class="d-flex align-center justify-center flex-column gap-4" v-else>
                    <div data-testid="drag-dropfile__upload-icon-wrapper"><img data-testid="drag-dropfile__upload-icon" src="/img/icons/UploadIconFile.svg" class="file-upload-icon" width="48" height="48" alt="File Upload RU File"/></div>
                    <h5 class="font-weight-medium" data-testid="drag-dropfile__upload-text">Drag and drop files here</h5>
                    <div data-testid="drag-dropfile__browse-button-wrapper">
                        <v-btn data-testid="drag-dropfile__browse-button" outlined @click.stop="openFilePicker">Browse files</v-btn></div>
                    <!-- <p>Drag a file here (or)<span data-testid="drag-dropfile__upload-link" class="text-decoration-underline blue--text ma-0 pa-0 px-2">upload a file</span></p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isDragging: false,
      fileName: '',
      localFiles: []
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingpercent: {
      type: Number,
      default: 0,
    },
    files:{
      type: [Array, File],
      default: () => []
    },
    accept:{
      type:String,
      default: '.xlsx,.xls,.xlsm,.xlsb,.doc,.docx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.svg,.mp4'
    },
    multiplefiles:{
      type:Boolean,
      default:true
    },
    resetTrigger: {  // New prop to trigger reset
      type: Boolean,
      default: false,
    },
  },
  mounted(){
    this.fileName="";
  },
  methods: {
    dragover(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    dragleave(event) {
      event.preventDefault();
      this.isDragging = false;
    },
    // Opens the file picker dialog programmatically
    openFilePicker() {
      if (this.$refs.file) {
        this.$refs.file.click();
      }
    },
    drop(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handleFiles(files);
    },
    onChange(event) {
      const files = event.target.files;
      this.handleFiles(files);
      // Reset file input so the same file can be added again after removal
      if (this.$refs.file) this.$refs.file.value = '';
    },
    handleFiles(files) {
      let newFiles = Array.from(files);
      let mergedFiles;

      // If single file mode, replace existing file instead of merging
      if (!this.multiplefiles) {
        mergedFiles = newFiles.slice(0, 1); // Take only the first file
      } else {
        // Merge new files with existing localFiles, avoiding duplicates by name
        mergedFiles = [...this.localFiles];
        newFiles.forEach(file => {
          if (!mergedFiles.some(f => f.name === file.name)) {
            mergedFiles.push(file);
          }
        });
      }

      // Filter out invalid files (by extension)
      const allowed = this.accept
        .replace(/\./g, '')
        .split(',')
        .map(ext => ext.trim().toLowerCase());
      let validFiles = mergedFiles.filter(file => {
        const ext = file.name.split('.').pop().toLowerCase();
        return allowed.includes(ext);
      });
      if (validFiles.length === 0) {
        this.localFiles = [];
        this.fileName = [];
      } else {
        this.localFiles = validFiles;
        this.fileName = validFiles;
      }
      this.$emit("update:files", this.localFiles);
    },
    removeFile(index) {
      this.localFiles.splice(index, 1);
      // Force new array reference for reactivity
      this.fileName = [...this.localFiles];
      this.$emit('update:files', this.localFiles);
    },
    resetFiles() {
      this.localFiles = [];
      this.fileName = [];
      if (this.$refs.file) this.$refs.file.value = '';
      this.$emit('update:files', []);
    },
  },
  watch: {
    files(newVal) {
      if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
        this.localFiles = [];
        this.fileName = [];
        if (this.$refs.file) this.$refs.file.value = '';
      } else {
        this.localFiles = Array.isArray(newVal) ? newVal : [];
        this.fileName = this.localFiles;
      }
    },
    resetTrigger(newVal) {
      if (newVal) {
        this.resetFiles();
      }
    },
  },
};
</script>



<style lang="scss" scoped>
.main {
    // display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
}

.dropzone-container {
    border-radius: 4px;
    background: white;
    border: 1px dashed #193541;
    width: 100%;
    padding: 40px;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 15px !important;
    display: block;
    cursor: pointer;
}

.selected-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
    padding: 0.5rem;
    background: #f9f9f9;
    border: 1px solid #193541;
    border-radius: 4px;
}

.file-name {
    flex-grow: 1;
    margin-right: 0.5rem;
}

.remove-icon {
    cursor: pointer;
    color: #f44336;
}
</style>